module.exports = __webpack_public_path__ + "static/img/3.49509a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/3.png
// module id = NIjc
// module chunks = 0